import { configureStore } from "@reduxjs/toolkit";
// Import your slices here
import userReducer from "./user/userSlice";
import vaultQuestionReducer from "./vaultQuestions/vaultQuestionSlice"; 
import dynamicFieldReducer from './dynamicField/dynamicFieldSlice'
export const store = configureStore({
  reducer: {
    user: userReducer, 
    vaultQuestion: vaultQuestionReducer,
    dynamicField: dynamicFieldReducer,
  },
});
